export default __webpack_public_path__ + "static/media/oil-change-selected.db35cceb.svg";